<template>
  <div class="app-header-icon">
    <svg-icon :icon-class="currentIcon" @click="handleClick" />
  </div>
</template>

<script>
import screenfull from 'screenfull';

export default {
  name: 'Screenfull',
  data() {
    return {
      isFullscreen: false
    };
  },
  computed: {
    currentIcon() {
      return this.isFullscreen ? 'ant-compress' : 'ant-expend';
    }
  },
  mounted() {
    this.init();
  },
  beforeUnmount() {
    this.destroy();
  },
  methods: {
    handleClick() {
      if (!screenfull.isEnabled) {
        this.$message({ message: '您的浏览器不支持全屏', type: 'warning' });
        return false;
      }
      screenfull.toggle();
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change);
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change);
      }
    }
  }
};
</script>
